import { render, staticRenderFns } from "./BlogAuthorSettings.vue?vue&type=template&id=c68b2374&scoped=true"
import script from "./BlogAuthorSettings.vue?vue&type=script&lang=js"
export * from "./BlogAuthorSettings.vue?vue&type=script&lang=js"
import style0 from "./BlogAuthorSettings.vue?vue&type=style&index=0&id=c68b2374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68b2374",
  null
  
)

export default component.exports